import { http, HttpResponse } from 'msw';
import { billingMocks } from '../mocks';

export const balancHandler = http.get(
  '*/billing/accounts/00000000-0000-0000-0000-000000000000/balance',
  () => HttpResponse.json(billingMocks.balanceMock)
);

export const subscriptionsHandler = http.get(
  '*/billing/accounts/00000000-0000-0000-0000-000000000000/subscriptions',
  () => HttpResponse.json(billingMocks.subbscriptionsMock)
);
